import { Equipment } from "@/modules/maintenance/services";
import monitorBloc from "../../services/bloc";
import { Vue } from "vue-class-component";
import { cloneDeep, eq, first, isEmpty, trim } from "lodash";

export class MonitorIndexPage extends Vue {
  monitorBloc = monitorBloc;
  equipments: any[] = [];
  equipmentCache: any[] = [];
  option = {
    equipment: 0,
    sensor: 0,
  };

  map: any = {
    center: [],
  };
  adv: any = {
    name: "",
    customField: {
      value: "",
    },
  };
  search = false;
  subscription: any = {
    alarm: null,
  };

  async unmounted() {
    this.subscription.alarm?.unsubscribe();
    this.monitorBloc.stopReadings();
  }

  async fetchEquipment(search: boolean = false) {
    const params: any = {
      length: 100,
      with: "customField",
    };

    if (search) {
      params.search = {
        advanced: this.adv,
      };
    }

    const equipments: any = await this.monitorBloc.getEquipments(params);
    if (!search) {
      this.option.equipment = 0;
      this.option.sensor = 0;
      this.option.equipment = equipments.data.data.length;
      for (const key in equipments.data.data) {
        const object = equipments.data.data[key];
        this.option.sensor += object.sensors.length;
      }
    }
    this.equipments = equipments.data.data.map((row: any) => {
      return {
        id: row.id,
        name: row.name,
        sensors: row.sensors,
        additional: row.additional,
        custom_field: row.custom_field,
        manufacturer: row.manufacturer,
        model: row.model,
        date_manufactured: row.date_manufactured,
        serial_number: row.serial_number,
      };
    });
    this.equipmentCache = [...this.equipments];
    this.fetchMap(equipments.data.data);
  }

  async fetchMap(equipments: Equipment[]) {
    if (equipments.length < 1) return;
    try {
      const equipment: any = first(equipments);
      const center = [
        equipment.site.additional.latitude as number,
        equipment.site.additional.longitude as number,
      ];
      this.map = {
        center,
      };
    } catch (e) {}
  }

  async searching() {
    const temp = [...this.equipmentCache];
    this.equipments = temp.filter((equipment) => {
      let cf = [];
      try {
        cf = equipment.custom_field.value.filter((row) => {
          return row.value
            .toLowerCase()
            .includes(this.adv.customField.value.toLowerCase());
        });
      } catch (e) {
        cf = [];
      }
      const isTrulyEmpty = (str) => isEmpty(trim(str));

      return (
        (!isTrulyEmpty(this.adv.name) &&
          equipment.name.toLowerCase().includes(this.adv.name.toLowerCase())) ||
        cf.length > 0
      );
    });
  }

  async reset() {
    this.equipments = [...this.equipmentCache];
  }
}
